<template>
  <div id="portal-body">
    <div class="portal-ad">
      <el-header class="QR-code-header" height="64px">
        <div class="QR-code-header-wrap">
          <span>二维码管理</span>
        </div>
      </el-header>
      <div class="portal-btn-box">
        <sw-button type="warning" size="main" @click="dialogFormVisible = true"
          >添加
        </sw-button>
        <sw-button type="danger" size="main" @click="deleteColumn"
          >删除
        </sw-button>
      </div>
      <div class="portalQR-column-content">
        <sw-table
          :tableName="'column-list'"
          :tableData="tableData"
          :tableTitle="tableTitle"
          :tableOperation="tableOperation1"
          :row-key="TableIndex"
          default-expand-all
          @selection-change="selectionChange"
          @operation-handle="operationHandle"
        >
        </sw-table>
      </div>
      <!-- 点击添加二维码弹出框 -->
      <sw-dialog title="添加二维码" :visible.sync="dialogFormVisible">
        <div class="edit">
          <el-form label-width="auto" :model="AddData" :rules="addrules">
            <el-form-item label="类型" prop="type">
              <el-select v-model="AddData.type" placeholder="--请选择--">
                <el-option label="进校" value="in"></el-option>
                <el-option label="出校" value="out"></el-option>
                <el-option label="进宿舍" value="drom"></el-option>
                <el-option label="大学城" value="fzu"></el-option>
                <el-option label="两代会" value="ldh"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="位置" prop="location">
              <el-input
                v-model="AddData.location"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="地址">
              <el-input
                v-model="AddData.url"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <sw-button @click="dialogFormVisible = false">取 消</sw-button>
          <sw-button type="primary" @click="OnAddData">确 定</sw-button>
        </div>
      </sw-dialog>

      <!-- 二维码弹出框 -->
      <sw-dialog
        title="查看二维码"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <!-- <div id="codeImg" ref="qrcodeContainer" style="width:100px;height:100px;"></div> -->
        <span
          ><vue-qr
            :text="qrCodeScene"
            colorDark="#333"
            colorLight="#fff"
            :size="160"
          ></vue-qr
        ></span>
        <span slot="footer" class="dialog-footer">
          <sw-button @click="dialogVisible = false">取 消</sw-button>
          <sw-button type="primary" @click="dialogVisible = false"
            >确 定</sw-button
          >
        </span>
      </sw-dialog>

      <!-- 点击编辑二维码 -->
      <!-- <sw-dialog title="编辑二维码" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="类型" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="--请选择--">
            <el-option label="进校" value="in"></el-option>
            <el-option label="出校" value="out"></el-option>
            <el-option label="进宿舍" value="drom"></el-option>
            <el-option label="大学城" value="fzu"></el-option>
            <el-option label="两代会" value="ldh"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="位置" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <sw-button @click="dialogFormVisible = false">取 消</sw-button>
        <sw-button type="primary" @click="dialogFormVisible = false">确 定</sw-button>
      </div>
    </sw-dialog> -->

      <!-- 编辑弹窗 -->
      <sw-dialog
        title="提示"
        :visible.sync="EditModel"
        width="50%"
        :before-close="handleEditClose"
      >
        <div class="edit">
          <el-form label-width="auto" :model="EditData" :rules="editRules">
            <el-form-item label="类型" prop="type">
              <el-select v-model="EditData.type" placeholder="--请选择--">
                <el-option label="进校" value="in"></el-option>
                <el-option label="出校" value="out"></el-option>
                <el-option label="进宿舍" value="drom"></el-option>
                <el-option label="大学城" value="fzu"></el-option>
                <el-option label="两代会" value="ldh"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="位置" prop="location">
              <el-input
                v-model="EditData.location"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            
            <!-- <el-form-item label="地址">
              <el-input
                v-model="EditData.url"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item> -->
          </el-form>

          <div>
            <sw-button @click="EditModel = false">取 消</sw-button>
            <sw-button type="primary" @click="EditModelOk">确 定</sw-button>
          </div>
        </div>
      </sw-dialog>
    </div>
  </div>
</template>

<script>
// import { getColumnList, deleteColumnList } from "@/api/cms-api";
import { getQRcodeList, saveCode, updateCode, batchDeleteQRcode } from "@/api/zhicheng";
//为生成二维码引入的
import VueQr from "vue-qr";
var portalBody;
export default {
  name: "QRcode",
  components: {
    VueQr,
  },
  data() {
    return {
      TableIndex: "0",
      qrCodeScene: "www.baidu.com",
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      dialogVisible: false,
      rootId: "000",
      AddData: {},
      tableData: [],
      tableLength: 0,
      showList: false,
      EditModel: false,
      EditData: {},
      height: "530px",
      tableTitle: [
        {
          prop: "type",
          label: "类型",
          width: "30",
          sortable: false,
        },
        {
          prop: "location",
          label: "位置",
          width: "30",
          sortable: false,
        },
        {
          prop: "url",
          label: "地址",
          width: "120",
          sortable: false,
        },
      ],
      tableOperation1: [
        {
          name: "查看二维码",
          icon: "su-icon-erweima",
          operation: "checkedQRcode",
        },
        {
          name: "复制",
          icon: "su-icon-taocanguanli",
          operation: "copyQRcode",
        },
        {
          name: "编辑二维码",
          icon: "su-icon-beizhu",
          operation: "editQRcode",
          // className: "editQRcode",
        },
        {
          name: "删除",
          icon: "su-icon-delete",
          operation: "delete",
        },
      ],
      tableSelect: [],
      searchColumn: "",
      total: 1,
      qrcontent: "",
      addrules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        location: [{ required: true, message: '请输入地点', trigger: 'blur' }]
      },
      editRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        location: [{ required: true, message: '请输入地点', trigger: 'blur' }]
      }
    };
  },
  created() {
    portalBody = document.getElementById("portal-body");
    this.handleColumnList();
  },
  mounted() {},
  beforeDestory() {
    // this.data.clipboard.destroy();
  },
  methods: {
    // 添加事件
    OnAddData() {
      // if(!this.AddData.url || !this.AddData.location)return this.$message.warning("信息不全！")
      // this.tableData.unshift(this.AddData);
      // this.TableIndex = parseInt(Math.random() * 100) + "";
      let data = {
        location: this.AddData.location,
        type: this.AddData.type
      }
      saveCode(data).then(res => {
        if(res.data.code == '0'){
          this.$message.success(res.data.message);
          this.dialogFormVisible = false;
          this.handleColumnList();
        }else{
          this.$message.success(res.data.message);
          this.dialogFormVisible = false;
        }
      })
     
    },
    // 编辑保存事件
    EditModelOk() {
      let data ={
        type: this.EditData.type,
        location: this.EditData.location,
        id: this.EditData.id
      }
      updateCode(data).then(res => {
        console.log(res.data)
        if(res.data.code == '0'){
          this.$message.success('保存成功');
          this.EditModel = false;
          this.handleColumnList();
        }else{
          this.$message.error(res.data.message)
        }
      })

      // this.tableData[this.EditData.index] = this.EditData;
      // this.EditModel = false;
      // this.TableIndex = parseInt(Math.random() * 100) + "";
      // console.log(
      //   this.EditData,
      //   this.tableData[this.EditData.index],
      //   this.TableIndex
      // );
    },
    handleEditClose() {
      this.EditModel = false;
    },
    operationHandle(id, operation, rowObj) {
      console.log(id, operation, rowObj);
      if (this[`${operation}Handle`]) {
        this[`${operation}Handle`](rowObj);
      }
    },
    async handleColumnList() {
      // let data = {
      //   columnName: this.searchColumn,
      //   id: "000",
      // };
      let res = await getQRcodeList();
      if(res.code == 0){
        this.tableData = res.data;
      }else{
        this.$message.error(res.message);
      }
    },
    //拖拽
    // searchHandle(val) {
    //   this.searchColumn = val;
    //   this.handleColumnList();
    // },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    searchHandle() {
      this.handleColumnList();
    },
    selectionChange(data) {
      this.tableSelect = data;
    },
    deleteColumn() {
      if (this.tableSelect && this.tableSelect.length === 0) {
        this.$message.error("请至少选择一条要删除的数据！");
        return false;
      }
      let ids = '';
      this.tableSelect.forEach((item) => {
        ids += item.id + ','
      });
      // if (ids.indexOf(this.rootId) >= 0) {
      //   this.$message.error("不可删除根目录，请重新选择！");
      //   return false;
      // }
      let data = {
        ids: ids,
      };
      this.confirmDialoag("确认要批量删除吗？", () => {
        batchDeleteQRcode(data).then(res => {
         console.log(res.data)
         if(res.data.code == '0'){
           this.$message.success('删除成功');
           this.handleColumnList();
         }else{
           this.$message.error(res.data.message)
         }
       })

      });
    },
    checkedQRcodeHandle(row) {
      this.qrCodeScene = row.url;
      this.dialogVisible = true;
    },
    copyQRcodeHandle(row) {
      let copyData = row.url;
      this.copy(copyData);
    },

    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },

    editQRcodeHandle(row) {
      this.EditData = { ...row };
      this.EditModel = true;
      console.log("编辑", row);
    },
    deleteHandle(row) {
      // if (row === this.rootId) {
      //   this.$message.error("至少选择一条数据！");
      //   return false;
      // }
      
      const data = {
        ids: row.id,
      };
      this.confirmDialoag("确定要删除吗？", () => {
        // this.tableData.splice(row.index, 1);
        // this.TableIndex = parseInt(Math.random() * 100) + "";
       batchDeleteQRcode(data).then(res => {
         console.log(res.data)
         if(res.data.code == '0'){
           this.$message.success('删除成功');
           this.handleColumnList();
         }else{
           this.$message.error(res.data.message)
         }
       })
      });
    },
    // deleteColumnList(data) {
    //   deleteColumnList(data).then((res) => {
    //     if (res.code === 0) {
    //       this.$message({
    //         message: "删除成功～",
    //         type: "success",
    //       });
    //       this.handleColumnList();
    //     } else {
    //       this.$message.error("删除失败");
    //     }
    //   });
    // },
    confirmDialoag(confirmText, confirmFn, cancelFn) {
      this.$confirm(confirmText)
        .then(() => {
          confirmFn && confirmFn();
        })
        .catch(() => {
          cancelFn && cancelFn();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.portal-ad {
  height: calc(100vh - 100px);

  .QR-code-header {
    background: #f8f9fe;
    box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
    span {
      width: 84.28px;
      height: 19px;
      font-size: 14px;
      line-height: 70px;
      font-family: simhei;
      padding: 0 2px;
      color: #ff9c38;
    }
    &-wrap {
      span {
        width: 1366px;
        height: 70px;
        padding-left: 7px;
        color: #ff9c38;
      }
    }
  }
  .portal-btn-box {
    margin: 16px 5px;
    button {
      border-radius: 5px;
      padding: 6px 10px;
    }
  }
}
/deep/ .sw-dialog.el-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss">
#portal-body {
  margin-left: 50px;
}
.su-icon-erweima:before {
  color: black;
  font-size: 14px;
}
.su-icon-taocanguanli::before {
  color: black;
  font-size: 14px;
}
</style>